module.exports = __webpack_public_path__ + "media/images/logo/logo_chariloto_5-c9f9aaa1bedb0f4a8c8b759b21534c1a.svg";